import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";

import App from "./App";

import { Login } from "./pages/Login";
import { Police } from "./pages/Police";
import { Error } from "./pages/Error";
import { NotFound } from "./pages/NotFound";
import { Access } from "./pages/Access";
import { getToken, getUser } from "./services/auth";
import { Register } from "./pages/CallCenter/Register";

const AppWrapper = (props: any) => {
  const [colorScheme, setColorScheme] = useState("dark");
  const [theme, setTheme] = useState("green");
  const [componentTheme, setComponentTheme] = useState("green");

  let location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const onColorSchemeChange = (scheme: string) => {
    changeStyleSheetUrl("layout-css", "layout-" + scheme + ".css", 1);
    changeStyleSheetUrl("theme-css", "theme-" + scheme + ".css", 1);
    setColorScheme(scheme);
  };

  const changeStyleSheetUrl = (id: any, value: any, from: any) => {
    const element = document.getElementById(id) as HTMLInputElement;
    const urlTokens = (element.getAttribute("href") as String).split("/");

    if (from === 1) {
      // which function invoked this function - change scheme
      urlTokens[urlTokens.length - 1] = value;
    } else if (from === 2) {
      // which function invoked this function - change color
      urlTokens[urlTokens.length - 2] = value;
    }

    const newURL = urlTokens.join("/");

    replaceLink(element, newURL);
  };

  const onMenuThemeChange = (theme: string) => {
    const layoutLink = document.getElementById("layout-css");
    const href = "assets/layout/css/" + theme + "/layout-" + colorScheme + ".css";

    replaceLink(layoutLink, href);
    setTheme(theme);
  };

  const onComponentThemeChange = (theme: string) => {
    const themeLink = document.getElementById("theme-css");
    const href = "assets/theme/" + theme + "/theme-" + colorScheme + ".css";

    replaceLink(themeLink, href);
    setComponentTheme(theme);
  };

  const replaceLink = (linkElement: any, href: string, callback?: any) => {
    const id = linkElement.getAttribute("id");
    const cloneLinkElement = linkElement.cloneNode(true);

    cloneLinkElement.setAttribute("href", href);
    cloneLinkElement.setAttribute("id", id + "-clone");

    linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

    cloneLinkElement.addEventListener("load", () => {
      linkElement.remove();
      const _linkElement = document.getElementById(id);
      _linkElement && _linkElement.remove();
      cloneLinkElement.setAttribute("id", id);

      if (callback) {
        callback();
      }
    });
  };

  const checkCallcenterUser = () => {
    const is_callcenter = getUser()?.is_callcenter;
    const acting_region_id = getUser()?.actingRegion?.id;
    const passenger_id = getUser()?.passenger_id;

    if (is_callcenter && (!acting_region_id || !passenger_id)) return false;

    return true;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login colorScheme={colorScheme} />} />
      <Route path="/login/:franchise" element={<Login colorScheme={colorScheme} />} />
      <Route path="/callcenter" element={<NotFound colorScheme={colorScheme} />} />
      <Route path="/callcenter/:callcenter" element={<Login colorScheme={colorScheme} />} />
      <Route path="/register" element={<Register colorScheme={colorScheme} />} />
      <Route path="/error" element={<Error colorScheme={colorScheme} />} />
      <Route path="/notfound" element={<NotFound colorScheme={colorScheme} />} />
      <Route path="/politica-de-privacidade" element={<Police colorScheme={colorScheme} />} />
      <Route path="/access" element={<Access colorScheme={colorScheme} />} />
      <Route
        path="*"
        element={
          getToken() && checkCallcenterUser() ? (
            <App
              colorScheme={colorScheme}
              onColorSchemeChange={onColorSchemeChange}
              componentTheme={componentTheme}
              onComponentThemeChange={onComponentThemeChange}
              theme={theme}
              onMenuThemeChange={onMenuThemeChange}
            />
          ) : (
            getUser()?.is_callcenter ? (
              <Navigate to={`/callcenter/${getUser()?.franchise?.id}`} />
            ) : (
              <Navigate to="/login" />
            )
            
          )
        }
      />
    </Routes>
  );
  // } else {
  //   return (
  //     <Routes>
  //       <Route path="/login" element={<Login colorScheme={colorScheme} />} />
  //       <Route path="*" element={<Navigate to="/login" />} />
  //     </Routes>
  //   );
  // }
};

export default AppWrapper;
